import AppBar from 'components/AppBar';
import React from 'react';

export default class View extends React.Component {
  render() {
    const {title, version, name, lifecycleState, unreliable, lifecycleOk, controls, warning, weaknetwork, multipleclients, ...other} = this.props;
    return (
      <div className="View">
        <AppBar title={title} unreliable={unreliable} warning={warning} weaknetwork={weaknetwork} name={name} multipleclients={multipleclients} version={version} lifecycleState={lifecycleState} lifecycleOk={lifecycleOk} controls={controls} />
        <div className="container">
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/View.js